import React, { useState } from 'react';

export default function Arrow({ color = '#FFFFFF', className }) {
    const [isHovered, setIsHovered] = useState(false);

    const currentColor = color;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
            <path d="M12.4112 2.06238C12.4473 1.67746 12.1645 1.33619 11.7796 1.30011L5.50707 0.712209C5.12215 0.676133 4.78087 0.95892 4.7448 1.34383C4.70872 1.72874 4.99151 2.07002 5.37642 2.1061L10.952 2.62868L10.4294 8.20424C10.3933 8.58915 10.6761 8.93043 11.061 8.96651C11.4459 9.00259 11.7872 8.7198 11.8233 8.33489L12.4112 2.06238ZM1 10.875L1.44663 11.414L12.1609 2.53606L11.7143 1.99706L11.2676 1.45805L0.553375 10.336L1 10.875Z" fill="#727272" />
        </svg>
    );
}